import { useRef, useState } from "react";
import { api } from "../services/api";
import ClearImageButton from "./ClearImageButton";

const TARGET_WIDTH = 158;

const CompanyLogoUpload = ({ onLogoChange, currentLogo }) => {
  const inputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  const resizeToWidth = (img, targetWidth) => {
    const scale = targetWidth / img.naturalWidth;
    const targetHeight = Math.round(img.naturalHeight * scale);

    const canvas = document.createElement("canvas");
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
    return canvas;
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setIsUploading(true);
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const dataUrl = String(ev.target?.result || "");
        const img = new Image();
        img.onload = async () => {
          const canvas = resizeToWidth(img, TARGET_WIDTH);
          canvas.toBlob(
            async (blob) => {
              if (!blob) throw new Error("Failed to create blob from canvas");
              const outFile = new File([blob], "logo.png", {
                type: "image/png",
              });
              const uploadedUrl = await api.uploadImage(outFile);
              onLogoChange(uploadedUrl);
            },
            "image/png",
            0.92
          );
        };
        img.onerror = () => {
          console.error("[CompanyLogoUpload] Failed to load image for resize");
        };
        img.src = dataUrl;
      };
      reader.readAsDataURL(file);
    } catch (err) {
      console.error("[CompanyLogoUpload] Upload failed", err);
    } finally {
      setIsUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="logo-upload">
      <label>Логотип компании</label>

      <div className="logo-preview" style={{ position: "relative" }}>
        {currentLogo ? (
          <>
            <img src={currentLogo} alt="Company Logo" className="logo-image" />
            <ClearImageButton
              onClick={() => {
                onLogoChange("");
                console.log("Logo cleared");
              }}
              title="Удалить логотип"
            />
          </>
        ) : (
          <div className="no-image-placeholder">No Logo</div>
        )}
      </div>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      <button
        className="upload-btn"
        onClick={handleButtonClick}
        disabled={isUploading}
      >
        {isUploading
          ? "Загрузка..."
          : currentLogo
          ? "Изменить логотип"
          : "Загрузить логотип"}
      </button>
    </div>
  );
};

export default CompanyLogoUpload;
